export default {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  convertObjectToRecord(obj: Record<string, any>): Record<string, string> {
    const record: Record<string, string> = {};
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const value = obj[key];
        if (value !== null && value !== undefined) {
          const strValue = String(value);
          record[key] = strValue ?? '';
        } else {
          record[key] = '';
        }
      }
    }
    return record;
  },
};
